export default __webpack_public_path__ + "static/media/flat_card_exaprint.caeff205.jpg";